export const SET_USER_DATA = 'SET_USER_DATA';
export const SET_USER_EXISTS = 'SET_USER_EXISTS';
export const SET_CURRENT_USER_SCHOOLS = 'SET_CURRENT_USER_SCHOOLS';
export const LOG_OUT = 'LOG_OUT';
export const SWITCH_ACCOUNT_REQUEST = 'SWITCH_ACCOUNT_REQUEST';
export const SWITCH_ACCOUNT_SUCCESS = 'SWITCH_ACCOUNT_SUCCESS';
export const SWITCH_ACCOUNT_FAILED = 'SWITCH_ACCOUNT_FAILED';



// WEBPACK FOOTER //
// ./src/store/modules/login/mutations.js